module.exports = __webpack_public_path__ + "img/Jarrad Hope.a5ddd7ed.jpg";